import React from "react";
import ReadOnlyRewardsDashboard from "./ReadOnlyRewardsDashboard";

function getEnv(key, fallback = "") {
  try {
    // eslint-disable-next-line no-undef
    const env = typeof process !== "undefined" && process?.env ? process.env : {};
    const v = String(env[key] || "").trim();
    return v || fallback;
  } catch {
    return fallback;
  }
}

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    this.setState({ info });
    // eslint-disable-next-line no-console
    console.error("UI crashed:", error, info);
  }

  render() {
    if (this.state.hasError) {
      const msg = this.state.error ? String(this.state.error) : "Unknown error";
      const stack = this.state.error && this.state.error.stack ? this.state.error.stack : "";
      return (
        <div style={{ padding: 24, fontFamily: "ui-sans-serif, system-ui" }}>
          <h2 style={{ margin: 0, marginBottom: 10 }}>Something went wrong</h2>
          <p style={{ marginTop: 0, opacity: 0.85 }}>
            The app loaded, but a rendering error occurred. Open the browser console (F12 → Console) and share the error
            text.
          </p>
          <div style={{ border: "1px solid #ddd", borderRadius: 12, padding: 12, background: "#fafafa" }}>
            <div style={{ marginBottom: 8, fontWeight: 700 }}>Error</div>
            <pre style={{ margin: 0, whiteSpace: "pre-wrap" }}>{msg}</pre>
            {stack ? (
              <>
                <div style={{ marginTop: 12, marginBottom: 8, fontWeight: 700 }}>Stack</div>
                <pre style={{ margin: 0, whiteSpace: "pre-wrap" }}>{stack}</pre>
              </>
            ) : null}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default function App() {
  const appName = getEnv("REACT_APP_APP_NAME", "ImaginatioNFT Rewards Viewer");
  return (
    <ErrorBoundary>
      <div className="min-h-screen bg-slate-50">
        <div className="w-full border-b border-slate-200 bg-white/70 backdrop-blur">
          <div className="mx-auto max-w-6xl px-4 py-3 flex items-center justify-between gap-3">
            <div className="font-semibold text-slate-900">{appName}</div>
            <div className="text-xs text-slate-500">Read-only viewer (no transactions)</div>
          </div>
        </div>

        <div className="mx-auto max-w-6xl px-4 py-6">
          <ReadOnlyRewardsDashboard />
        </div>
      </div>
    </ErrorBoundary>
  );
}
